<div class="app-loading-spinner"></div>